import type { GroupSelection } from '../entry/groupFilter';

/**
 * Group-scoped bulk platform toggle for the UNWINDER. Mirrors the opener's
 * bulk scope, but resolves membership server-side via `groupId` — the
 * unwinder positions list isn't client-filtered by group (its row model
 * doesn't carry openerGroupId), so there are no client-side rule ids to send.
 *
 * The control is gated to a concrete group selection (`kind === 'group'`):
 * 'all' and 'ungrouped' have no safe group scope here, so the bulk buttons
 * are disabled in those states (see UnwindingPage) and we never accidentally
 * flip the whole account. The defensive branch below collapses any
 * non-group selection to a single account-wide payload, but the UI never
 * fires it.
 */
export interface BulkPlatformDto {
  scope?: 'all' | 'ids';
  ruleIds?: string[];
  groupId?: string;
  platform: 'kalshi' | 'polymarket';
  enabled: boolean;
}

export function buildBulkPlatformDtos(
  selection: GroupSelection,
  platform: 'kalshi' | 'polymarket',
  enabled: boolean
): BulkPlatformDto[] {
  if (selection.kind === 'group') {
    return [{ scope: 'all', groupId: selection.groupId, platform, enabled }];
  }
  return [{ scope: 'all', platform, enabled }];
}
